import { Fab, makeStyles, Tooltip } from '@material-ui/core'
import React from 'react'
import { Clipboard } from 'react-feather'
import { useClipboard } from '../use-clipboard'

type Props = {
  tooltip: string
  getText: () => string
  disabled: boolean
}

const useStyles = makeStyles((theme) => ({
  fab: {
    zIndex: 1,
    position: 'absolute',
    marginRight: -theme.spacing(1),
  },
}))

export function ClipboardButton({
  tooltip,
  getText,
  disabled,
}: Props): React.ReactElement {
  const classes = useStyles()
  const { copyToClipboard } = useClipboard()

  const onCopyToClipboardHandler = async () => {
    await copyToClipboard(getText)
  }

  return (
    <Tooltip title={tooltip}>
      <span className={classes.fab}>
        <Fab
          color="default"
          size="small"
          onClick={onCopyToClipboardHandler}
          disabled={disabled}
        >
          <Clipboard />
        </Fab>
      </span>
    </Tooltip>
  )
}
